import React, { VFC } from 'react';
import styled, { css } from 'styled-components';
import { useSettings } from '../../contexts/settingsContext';
import { theme } from '../../utils/theme';
import Typography from '../atoms/Typography';

interface Props extends React.HTMLProps<HTMLDivElement | HTMLButtonElement> {
  active: boolean;
  onClick: () => void;
}

interface Idiv {
  active: boolean;
  color: string;
}

const StyledDiv = styled.div<Idiv>`
  cursor:pointer;
  display:block;
  padding: 16px 40px;
  ${({ active, color }) =>
    active &&
    css`
      border-bottom: 2px solid ${color};
    `}
}
`;

const StyledText = styled(Typography)`
  ${StyledDiv}:hover & {
    color: ${theme.colors.grey[100]};
  }
  font-weight: 600;
`;

const Tab: VFC<Props> = ({ active = true, children, onClick }) => {
  const { interactionColor } = useSettings();

  return (
    <StyledDiv color={interactionColor} active={active} onClick={onClick}>
      <StyledText
        color={active ? theme.colors.grey[100] : theme.colors.grey[60]}
      >
        {children}
      </StyledText>
    </StyledDiv>
  );
};

export default Tab;
